<template>
  <div v-if="sermon">
    <audio
      ref="audio"
      @loadstart="loadStart"
      @durationchange="durationChange"
      @canplay="canPlay"
      @canplaythrough="canPlayThrough"
      @progress="progress"
      @playing="playing"
      @pause="pause"
      @timeupdate="timeUpdate"
      @volumechange="volumeChange"
    >
      <source :src="sourceFile" type="audio/mpeg" />Your browser does not support the audio tag.
    </audio>
    <v-progress-linear v-show="loading" height="3" :indeterminate="true" style="width: 100%;"></v-progress-linear>
    <v-container fluid grid-list-lg fill-height>
      <v-layout row wrap justify-center align-center>
        <!-- sm6 md5 order-xs2 order-sm1 -->
        <v-flex xs12>
          <v-card flat>
            <v-img
              :src="cover(sermon, 1)"
              :aspect-ratio="4/3"
              class="black shrink"
              max-height="277px"
              contain
            ></v-img>
            <v-card-title primary-title class="justify-center text-xs-center">
              <!-- <v-flex order-xs2 order-sm1>
                <v-btn icon outline @click="prev" class="prev">
                  <v-icon>chevron_left</v-icon>
                </v-btn>
              </v-flex>-->
              <!-- <v-flex xs12 sm8 order-xs1 order-sm2> -->
              <div :class="{ 'mx-3': $vuetify.breakpoint.mdAndUp }">
                <div class="headline">{{ sermon.title }}</div>
                <div>{{ sermon.scripture }} • {{ sermon.speaker }}</div>
              </div>
              <!-- </v-flex> -->
              <!-- <v-flex order-xs3 order-sm3>
                <v-btn icon outline @click="next" class="next">
                  <v-icon>chevron_right</v-icon>
                </v-btn>
              </v-flex>-->
            </v-card-title>

            <v-card-actions>
              <div
                class="progress"
                @mouseover="float = true"
                @mousemove="moveFloat"
                @mouseleave="float = false"
              >
                <v-progress-linear
                  ref="trackProgress"
                  @click="seek"
                  color="red"
                  background-color="grey darken-1"
                  height="5"
                  class="my-0 grey lighten-1"
                  v-model="percentComplete"
                  :buffer-value="bufferValue"
                ></v-progress-linear>
                <div ref="progressFloat" :class="float ? 'show' : ''" class="progress-float">00:00</div>
              </div>
            </v-card-actions>

            <v-layout align-center wrap>
              <v-flex xs12 sm8>
                <v-card-actions class="justify-space-between">
                  <span>{{ convertCurrent }}</span>
                  <v-btn icon @click="replay10">
                    <v-icon>replay_10</v-icon>
                  </v-btn>
                  <v-btn icon @click="playPause">
                    <v-icon>{{ icon }}</v-icon>
                  </v-btn>
                  <v-btn icon @click="forward10">
                    <v-icon>forward_10</v-icon>
                  </v-btn>
                  <span>{{ convertDuration }}</span>
                </v-card-actions>
              </v-flex>
              <v-flex xs12 sm4 class="py-0">
                <v-slider v-model="volume" :prepend-icon="volumeIcon" @click:prepend="muteUnmute"></v-slider>
              </v-flex>
              <v-flex xs12>
                <v-btn block outline round @click="download(sermon)">
                  <v-icon left>file_download</v-icon>
                  <span>Download</span>
                </v-btn>
              </v-flex>
              <!-- <v-flex xs6>
                <v-btn block outline round @click="showSlides(sermon)">
                  <v-icon left>photo_library</v-icon>
                  <span>Show Slides</span>
                </v-btn>
              </v-flex>-->
            </v-layout>
          </v-card>
        </v-flex>
        <!-- <v-flex xs12 sm6 md7 order-xs1 order-sm2>
        <v-card color="black" dark flat tile>
          <v-window v-model="this.currentSlide">
            <v-window-item v-for="(item, n) in sermon.breakpoints" :key="`card-${n}`">
              <v-img
                :src="slide(sermon, item.slide)"
                :aspect-ratio="4/3"
                class="grey lighten-2 shrink"
                @error="imageLoadError"
                max-height="70vh"
                contain
              ></v-img>
            </v-window-item>
          </v-window>
        </v-card>
        </v-flex>-->
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import ImageMixin from "@/mixins/imageMixin";
import AuthenticationService from "@/services/AuthenticationService";
export default {
  props: ["sermon"],
  data() {
    return {
      volume: 0,
      currentTime: 0,
      duration: 0,
      bufferValue: 0,
      icon: "",
      float: false,
      volumeIcon: "",
      loading: true,
      shownImage: "",
      currentSlide: 0
    };
  },
  methods: {
    loadSermon() {
      this.$refs.audio.load();
      this.loading = true;
      // console.log(this.$refs.audio);
    },
    // Fires when the browser starts looking for the audio/video
    loadStart() {
      this.volume = 10;
      this.currentTime = 0;
      this.duration = this.$refs.audio.duration;
      this.icon = "play_circle_outline";
    },
    // Fires when the duration of the audio is changed
    durationChange() {
      // Sets the full duration
      this.duration = this.$refs.audio.duration;
    },
    // Fires when the browser can start playing the audio
    canPlay() {
      // console.log("canplay");
      this.loading = false;
      this.$refs.audio.play();
      this.updateTimeBuffered();
    },
    // Fires when the browser can play through the audio without stopping for buffering
    // Fires when the browser is downloading the audio
    canPlayThrough() {
      // console.log("canPlayThrough");
      this.updateTimeBuffered();
    },
    progress() {
      // console.log("progress");
      this.updateTimeBuffered();
    },
    updateTimeBuffered() {
      var length = this.$refs.audio.buffered.length;
      // Checks if has buffered parts of the audio
      if (length > 0) {
        this.duration = this.$refs.audio.duration;
        if (this.duration > 0) {
          /**
           * Check all start of the buffered parts starting from the highest,
           * then compare each one to the current time
           */
          for (var i = 0; i < length; i++) {
            var index = length - 1 - i;
            if (
              this.$refs.audio.buffered.start(index) <
              this.$refs.audio.currentTime
            ) {
              this.bufferValue =
                (this.$refs.audio.buffered.end(index) / this.duration) * 100;
              break;
            }
            // console.log(this.bufferValue);
          }
        }
      }
    },
    // Fires when the audio is playing after having been paused or stopped for buffering
    playing() {
      this.icon = "pause_circle_outline";
    },
    // Fires when the audio has been paused
    pause() {
      this.icon = "play_circle_outline";
    },
    // Fires when the current playback position has changed
    timeUpdate() {
      this.currentTime = this.$refs.audio.currentTime;
      // console.log(this.currentTime);
    },
    seek(e) {
      const rect = this.$refs.trackProgress.$el.getBoundingClientRect();
      const seekPos = (e.clientX - rect.left) / rect.width;
      this.$refs.audio.currentTime = seekPos * this.duration;
    },
    moveFloat(e) {
      let float = this.$refs.progressFloat;
      let trackProgress = this.$refs.trackProgress.$el;

      let left = e.pageX - trackProgress.getBoundingClientRect().left;
      let targetTime = (left * this.duration) / trackProgress.clientWidth;

      float.style.left = `${left}px`;
      float.textContent = this.parseTime(targetTime);
    },
    // Fires when volume is changed
    volumeChange() {
      // console.log(this.$refs.audio.volume);
      this.volume = this.$refs.audio.volume * 100;
      if (this.$refs.audio.volume !== 0 && !this.$refs.audio.muted) {
        // Volume is not muted and not zero
        this.volumeIcon = "volume_up";
      } else {
        // Volume is muted and 0
        this.volumeIcon = "volume_off";
      }
    },
    playPause() {
      if (!this.$refs.audio.paused && !this.$refs.audio.ended) {
        this.$refs.audio.pause();
      } else {
        this.$refs.audio.play();
      }
    },
    muteUnmute() {
      if (this.$refs.audio.muted) {
        this.$refs.audio.muted = false;
      } else {
        this.$refs.audio.muted = true;
      }
    },
    replay10() {
      this.$refs.audio.currentTime -= 10;
    },
    forward10() {
      this.$refs.audio.currentTime += 10;
    },
    parseTime(time) {
      let hh = parseInt(time / 3600);
      let mm = ("0" + parseInt((time % 3600) / 60)).slice(-2);
      let ss = ("0" + parseInt(time % 60)).slice(-2);
      // return (
      //   ("0" + parseInt(time / 60)).slice(-2) +
      //   ":" +
      //   ("0" + parseInt(time % 60)).slice(-2)
      // );
      return hh > 0 ? `${hh}:${mm}:${ss}` : `${mm}:${ss}`;
    },
    next() {
      let length = this.$props.sermon.breakpoints.length;
      this.currentSlide =
        this.currentSlide + 1 === length ? 0 : this.currentSlide + 1;
    },
    prev() {
      let length = this.$props.sermon.breakpoints.length;
      this.currentSlide =
        this.currentSlide - 1 < 0 ? this.length - 1 : this.currentSlide - 1;
    },
    async download(sermon) {
      const link = document.createElement("a");
      link.href = `${process.env.SERVER_URI}/sermons/download/${sermon._id}`;
      link.setAttribute("download", ""); //or any other extension
      document.body.appendChild(link);
      link.click();
      link.remove();
    },
    showSlides() {}
  },
  watch: {
    volume(value) {
      this.$refs.audio.volume = this.volume / 100;
    },
    currentTime(value) {
      // let length = this.$props.sermon.breakpoints.length;
      // for (let i = 0; i < length; i++) {
      // const curEl = this.$props.sermon.breakpoints[this.currentSlide];
      // const nextEl = this.$props.sermon.breakpoints[this.currentSlide + 1];
      // console.log(this.currentSlide);
      // console.log(this.curEl);
      // if (value >= curEl.time && value <= nextEl.time) {
      //   this.next();
      //   console.log(this.currentSlide);
      // }
      // }
      // let length = this.$props.sermon.breakpoints.length;
      // if (
      //   this.currentSlide < length && this.$props.sermon.breakpoints
      //   value >= this.$props.sermon.breakpoints[this.currentSlide].time
      // ) {
      //   console.log(this.currentSlide);
      //   this.currentSlide++;
      // }
    }
  },
  computed: {
    sourceFile() {
      return `${this.baseUrl}/sermons/${this.coverFolder(this.sermon)}/${
        this.sermon.mp3
      }`;
    },
    convertCurrent() {
      return this.parseTime(this.currentTime);
    },
    convertDuration() {
      return this.parseTime(this.duration);
    },
    percentComplete() {
      return (this.currentTime / this.duration) * 100;
    }
  },
  mixins: [ImageMixin]
};
</script>

<style>
.progress {
  position: relative;
  width: 100%;
  box-sizing: border-box;
}
.progress-float {
  position: absolute;
  display: none;
  bottom: 100%;
  border: 1px solid rgba(0, 0, 0, 0.2);
  transform: translate(-50%, -10px);
  background-color: #212121;
  color: #fff;
  font-size: 14px;
  padding: 4px;
  -webkit-user-select: none;
  -moz-user-select: -moz-none;
  -ms-user-select: none;
  user-select: none;
}
.progress-float::before {
  content: "";
  display: block;
  position: absolute;
  left: 50%;
  bottom: -1px;
  transform: translate(-50%, 100%);
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.2) transparent transparent transparent;
  border-width: 5px 5px 0 5px;
}
.progress-float::after {
  content: "";
  display: block;
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translate(-50%, 100%);
  border-style: solid;
  border-color: #212121 transparent transparent transparent;
  border-width: 5px 5px 0 5px;
}
.progress-float.show {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/SermonPlayer.vue